import { useEffect, useReducer, useState } from "react";
import { useOrder } from "../../../hook/useOrder";
import { useDispatch, useSelector } from "react-redux";
import { backdropActions } from "../../../store/backdrop-slice";
import Modal from "../../Modal";

export function AddToCart(props) {
  const { product } = props;
  const isFixedValidity = Number(product.validity_mode) === 1;

  const [count, setCount] = useState(1);

  const { addToCart } = useOrder();

  let cartItems = useSelector((state) => state.order.cartOrders);

  const modalReducer = (state, action) => {
    switch (action.type) {
      case "show":
        return { ...state, show: !state.show };

      case "data":
        return { ...state, data: action.data };
    }
  };

  const [modalstate, modaldispatch] = useReducer(modalReducer, {
    show: false,
    data: null,
  });

  let dispatch = useDispatch();


  return (
    <div
      className="mt-3"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <label>Count: </label>
      <input
        type="number"
        className="mb-1"
        value={count}
        min={1}
        disabled={isFixedValidity}
        onChange={(event) => {
          setCount(parseInt(event.target.value));
        }}
      />
      {isFixedValidity && <small className="text-muted mb-1">Feste Laufzeit: Die Menge verlängert den Gültigkeitszeitraum nicht.</small>}

      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => {
          addToCart({
            product,
            count: isFixedValidity ? 1 : count,
          });

          setCount(1);

          modaldispatch({
            type: "data",
            data: {
              body: <div>Added to Cart</div>,
            },
          });
          modaldispatch({
            type: "show",
          });
          dispatch(backdropActions.toggleBackdrop());
        }}
      >
        Add to cart
      </button>

      {modalstate.show && modalstate.data && (
        <Modal
          body={modalstate.data.body}
          hideCopy={true}
          onClose={() => {
            modaldispatch({
              type: "show",
            });
            dispatch(backdropActions.toggleBackdrop());
          }}
        />
      )}
    </div>
  );
}
